import { useState } from 'react'
import { colors, FormControlLabel, Switch } from '@mui/material'

const SwitchBtn = ({
	onClick,
	className,
	label,
	size,
	labelColor,
	checked = false,
	setChecked = () => {},
	...rest
}) => {

	const handleChange = (event) => {
		setChecked(event.target.checked)
		if (onClick) onClick(event)
	}

	// Define default and large size styles
	const SWITCH_STYLE = {
		width: size === 'lg' ? 35 : 28, // large or default width
		height: size === 'lg' ? 20 : 16, // large or default height
		padding: 0,
		'& .MuiSwitch-switchBase': {
			padding: 0,
			margin: '2px',
			transitionDuration: '300ms',
			'&.Mui-checked': {
				transform:
					size === 'lg' ? 'translateX(16px)' : 'translateX(12px)', // adjust transform for large size
				color: '#fff',
				'& + .MuiSwitch-track': {
					backgroundColor: '#7CA6BD',
					opacity: 1,
					border: 0,
				},
				'&.Mui-disabled + .MuiSwitch-track': {
					opacity: 0.5,
				},
			},
			'&.Mui-focusVisible .MuiSwitch-thumb': {
				color: '#33cf4d',
				border: '6px solid #fff',
			},
			'&.Mui-disabled .MuiSwitch-thumb': {
				color: '#ccc',
			},
			'&.Mui-disabled + .MuiSwitch-track': {
				opacity: 0.7,
			},
		},
		'& .MuiSwitch-thumb': {
			boxSizing: 'border-box',
			width: size === 'lg' ? 16 : 12, // large or default thumb width
			height: size === 'lg' ? 16 : 12, // large or default thumb height
		},
		'& .MuiSwitch-track': {
			borderRadius: size === 'lg' ? 13 : 13, // keep border radius the same
			backgroundColor: '#C3D6E1',
			opacity: 1,
			transition: 'background-color 0.5s',
		},
	}

	const LABEL_STYLE = {
		'&.MuiFormControlLabel-root': {
			margin: '0 !important',
		},
		'& .MuiFormControlLabel-label': {
			color: labelColor || '#7CA6BD', // Use the custom label color or fallback to the default
			fontSize: '0.8rem',
			fontWeight: 400,
			marginLeft: '5px',
		},
	}

	return (
		<FormControlLabel
			className={`${className}`}
			control={
				<Switch
					checked={checked}
					onChange={handleChange}
					sx={SWITCH_STYLE}
				/>
			}
			label={label ? `${label}` : ''}
			sx={LABEL_STYLE}
			{...rest}
		/>
	)
}

export default SwitchBtn
